module.exports = __webpack_public_path__ + "static/media/search-line.64d0f22f.svg";